import Component from "@lib/Component.js";
import { setStyle } from "@qneyraud/q-utils";
import { gebc, addEvent, removeEvent, qsa } from "@qneyraud/q-utils/umd/q-utils";
import gsap from "gsap";

const wait = (n) => {
  return new Promise((resolve) => {
    window.setTimeout(resolve, n);
  });
};

export default class NewsList extends Component {
  init() {
    super.init();
    this.bindMethods();
  }

  onEnterCompleted() {
    super.onEnterCompleted();

    this.masonryContainer = this.refs["grid-container"];
    this.masonryItems = Array.isArray(this.refs["grid-item"]) ? this.refs["grid-item"] : [this.refs["grid-item"]];
    this.filterSelect = this.getFilterSelect();

    if (this.masonryItems.length === 0) return;

    this.filter = "all";

    this.initEvents();

    this.waitImages(this.masonryContainer)
      .then(wait.bind(null, 150))
      .then(this.initMasonry.bind(this));
  }

  onLeaveCompleted() {
    super.onLeaveCompleted();
    this.filterSelect.off("change", this.onFilterChange);
    removeEvent(window, "resize");
  }

  bindMethods() {
    this.onFilterChange = this.onFilterChange.bind(this);
    this.onResize = this.onResize.bind(this);
  }

  initEvents() {
    this.filterSelect.on("change", this.onFilterChange);
    addEvent(window, "resize", this.onResize);
  }

  onResize() {
    this.numberOfcolumns = this.getNumberOfColumns();
    this.placeFilteredItems();
  }

  getFilterSelect() {
    return this.children.find((child) => child.id === "input");
  }

  getFilteredItems() {
    return this.masonryItems.filter((el) => {
      if (gebc(el, "thumbnail").dataset) {
        const type = gebc(el, "thumbnail").dataset.category;

        return this.filter === "all" || this.filter === type;
      }

      return "all";
    });
  }

  waitImages(parentEl) {
    const promises = qsa(parentEl, "img").map((el) => {
      return new Promise((resolve, reject) => {
        let img = new Image();
        img.onload = resolve;
        img.onerror = reject;

        img.src = el.src;
      });
    });

    return Promise.all(promises);
  }

  onFilterChange(newValue) {
    this.filter = newValue;
    this.resetColumns();

    const tl = gsap
      .timeline({
        paused: true,
        onComplete: () => {
          this.updateContainerHeight();
        }
      })
      .add("hide", 0)
      .add("show", 0);

    this.masonryItems.forEach((el) => {
      const type = gebc(el, "thumbnail").dataset.category;

      if (newValue === "all" || newValue === type) {
        const { xPercent, y } = this.getItemPosition(el);

        setStyle(el, {
          left: xPercent + "%",
          top: y + "px",
          opacity: 1
        });
      } else {
        setStyle(el, {
          opacity: 0
        });
      }
    });

    tl.play();
  }

  placeFilteredItems() {
    this.resetColumns();

    this.getFilteredItems().forEach((el) => {
      const { xPercent, y } = this.getItemPosition(el);

      setStyle(el, {
        top: y + "px",
        left: xPercent + "%"
      });
    });
    this.updateContainerHeight();
  }

  initMasonry() {
    this.numberOfcolumns = this.getNumberOfColumns();

    setStyle(this.masonryContainer, {
      position: "relative"
    });
    setStyle(this.masonryItems, {
      position: "absolute",
      height: "auto"
    });

    this.placeFilteredItems();
  }

  getItemPosition(el) {
    const columnIndex = this.getSmallestColumnIndex();

    const datas = {
      xPercent: columnIndex * (100 / this.numberOfcolumns),
      y: this.columns[columnIndex].totalHeight
    };

    const margins = parseInt(window.getComputedStyle(el).marginTop) + parseInt(window.getComputedStyle(el).marginBottom);
    this.columns[columnIndex].totalHeight += el.clientHeight + margins;

    return datas;
  }

  getNumberOfColumns() {
    const { innerWidth: w } = window;

    if (w > 1200) return 3;
    if (w > 768) return 2;
    return 1;
  }

  resetColumns() {
    this.columns = [];

    for (let i = 0; i < this.numberOfcolumns; i++) {
      this.columns[i] = {
        index: i,
        totalHeight: 0
      };
    }
  }

  getSmallestColumnIndex() {
    return this.columns.slice().sort((a, b) => a.totalHeight - b.totalHeight)[0].index;
  }

  updateContainerHeight() {
    const heights = this.columns.map((column) => column.totalHeight);
    const maxHeight = Math.max(...heights);

    setStyle(this.masonryContainer, {
      height: maxHeight + "px"
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/components/NewsList.js